var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _g, _path2, _g2, _path3, _g3, _circle, _circle2, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebpushNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_15549)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4759 20.6023L24.0033 18.9375V15.3125C24.0033 15.1742 23.8916 15.0625 23.7533 15.0625H18.2533C18.115 15.0625 18.0033 15.1742 18.0033 15.3125V18.9375L17.5306 20.6023C17.472 20.7656 17.5923 20.9375 17.7658 20.9375H24.2408C24.4142 20.9375 24.5345 20.7656 24.4759 20.6023ZM18.5658 15.625H23.4408V18.7109H18.5658V15.625ZM20.3494 20.375L20.4127 20.0859H21.5869L21.6502 20.375H20.3494ZM22.0994 20.375L21.9502 19.6977C21.9439 19.6687 21.9181 19.6484 21.8892 19.6484H20.1111C20.0814 19.6484 20.0564 19.6687 20.0502 19.6977L19.9009 20.375H18.1798L18.5103 19.2109H23.4962L23.8267 20.375H22.0994Z",
    fill: "#FFF4F0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_15549)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_15549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_15549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_15549)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_15549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3893 49.5324L62.6 48.3484V44.2984C62.6 43.8025 62.195 43.3984 61.7 43.3984H56.3C55.8045 43.3984 55.4 43.8025 55.4 44.2984V48.3484L54.6107 49.5324C54.5 49.6984 54.5 49.7943 54.5 49.9234V50.1484C54.5 50.3734 54.725 50.5984 54.9496 50.5984H63.0504C63.275 50.5984 63.5 50.3734 63.5 50.1484V49.9234C63.5 49.7943 63.5 49.6984 63.3893 49.5324ZM57.65 49.6984L57.92 49.2484H60.08L60.35 49.6984H57.65ZM61.7 47.8984H56.3V44.2984H61.7V47.8984Z",
    fill: "#394353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_15549",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_15549",
    result: "effect2_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_15549",
    result: "effect3_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_15549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_15549",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_15549",
    result: "effect2_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_15549",
    result: "effect3_dropShadow_937_15549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_15549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_15549",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_15549"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_15549",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_15549"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_15549",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_15549"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_15549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(54.5 42.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpushNode);
export default __webpack_public_path__ + "static/media/webpushNode.5074bb13ad8a51ab413db727175e7a2e.svg";
export { ForwardRef as ReactComponent };